// extracted by mini-css-extract-plugin
export default {"productGrid":"z1-z","centerLink":"A1-z","productSection":"B1-z","item":"C1-z","ctaButton":"D1-z"};